// @ts-nocheck



import { createAction, createSlice } from '@reduxjs/toolkit';
import type { OsagoCalculation } from '../lib/types';




export const ADD_OSAGO_CALCULATION = 'vehicles/osago-calculations/add';
export const UPDATE_OSAGO_CALCULATION = 'vehicles/osago-calculations/update';
export const DELETE_OSAGO_CALCULATION = 'vehicles/osago-calculations/delete';
export const SET_SELECTED_VEHICLES =
'vehicles/osago-calculations/set-selected-vehicles';
export const ADD_FILTER_OSAGO_CALCULATION =
'vehicles/osago-calculations/filter/add';
export const ADD_UNSELECT_OSAGO_CALCULATION =
'vehicles/osago-calculations/unselect/add';
export const SET_FILTER_OSAGO_CALCULATION =
'vehicles/osago-calculations/filter/set';
export const SET_UNSELECT_OSAGO_CALCULATION =
'vehicles/osago-calculations/unselect/set';
export const CLEAR = 'vehicles/osago-calculations/clear';








type OsagoCalculationState = {
  selectedVehicleIds: Array<number | string>;
  freeVehicleItems: OsagoCalculation[];
  filter: Record<string, unknown>;
  unSelectedVehicleIds: Record<string, unknown>;
};

type OsagoCalculationFilterPayload = { filter: Record<string, unknown> };
type OsagoCalculationSelectionPayload = {
  selectedVehicleIds: Array<number | string>;
};
type OsagoCalculationUnselectedPayload = {
  unSelectedVehicleIds: Record<string, unknown>;
};

const defaultState: OsagoCalculationState = {
  selectedVehicleIds: [],
  freeVehicleItems: [],
  filter: {},
  unSelectedVehicleIds: {}
};

const addOsagoCalculationAction = createAction<{ osagoCalculation: OsagoCalculation }>(ADD_OSAGO_CALCULATION);
const updateOsagoCalculationAction = createAction<{ osagoCalculation: OsagoCalculation }>(UPDATE_OSAGO_CALCULATION);
const deleteOsagoCalculationAction = createAction<{ id: number }>(DELETE_OSAGO_CALCULATION);
const setSelectedVehiclesAction = createAction<OsagoCalculationSelectionPayload>(SET_SELECTED_VEHICLES);
const addFilterOsagoCalculationAction = createAction<OsagoCalculationFilterPayload>(
  ADD_FILTER_OSAGO_CALCULATION
);
const addUnselectOsagoCalculationAction = createAction<OsagoCalculationUnselectedPayload>(
  ADD_UNSELECT_OSAGO_CALCULATION
);
const setFilterOsagoCalculationAction = createAction<OsagoCalculationFilterPayload>(
  SET_FILTER_OSAGO_CALCULATION
);
const setUnselectOsagoCalculationAction = createAction<OsagoCalculationUnselectedPayload>(
  SET_UNSELECT_OSAGO_CALCULATION
);
const clearAction = createAction(CLEAR);

const osagoCalculationSlice = createSlice({
  name: 'osagoCalculation',
  initialState: defaultState as OsagoCalculationState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(setUnselectOsagoCalculationAction, (state, { payload }) => ({
      ...state,
      unSelectedVehicleIds: payload.unSelectedVehicleIds
    })).
    addCase(addUnselectOsagoCalculationAction, (state, { payload }) => ({
      ...state,
      unSelectedVehicleIds: {
        ...state.unSelectedVehicleIds,
        ...payload.unSelectedVehicleIds
      }
    })).
    addCase(setFilterOsagoCalculationAction, (state, { payload }) => ({
      ...state,
      filter: payload.filter
    })).
    addCase(addFilterOsagoCalculationAction, (state, { payload }) => ({
      ...state,
      filter: { ...state.filter, ...payload.filter }
    })).
    addCase(addOsagoCalculationAction, (state, { payload }) => ({
      ...state,
      freeVehicleItems: [...state.freeVehicleItems, payload.osagoCalculation]
    })).
    addCase(deleteOsagoCalculationAction, (state, { payload }) => ({
      ...state,
      freeVehicleItems: state.freeVehicleItems.filter(
        (item) => item.id !== payload.id
      )
    })).
    addCase(setSelectedVehiclesAction, (state, { payload }) => ({
      ...state,
      selectedVehicleIds: payload.selectedVehicleIds
    })).
    addCase(updateOsagoCalculationAction, (state, { payload }) => {
      const freeVehicleItems = [...state.freeVehicleItems];
      const index = freeVehicleItems.findIndex(
        (item) => item.id === payload.osagoCalculation.id
      );
      if (index >= 0) {
        freeVehicleItems.splice(index, 1, {
          ...freeVehicleItems[index],
          ...payload.osagoCalculation
        });
        return {
          ...state,
          freeVehicleItems
        };
      }
      return state;
    }).
    addCase(clearAction, () => defaultState);
  }
});

export const osagoCalculationActions = {
  add: (osagoCalculation) =>
  addOsagoCalculationAction({ osagoCalculation }),
  update: (osagoCalculation) =>
  updateOsagoCalculationAction({ osagoCalculation }),
  delete: (id) => deleteOsagoCalculationAction({ id }),
  setSelectedVehicles: (selectedVehicleIds) =>
  setSelectedVehiclesAction({ selectedVehicleIds }),
  addFilter: (filter) => addFilterOsagoCalculationAction({ filter }),
  addUnselect: (unSelectedVehicleIds) =>
  addUnselectOsagoCalculationAction({ unSelectedVehicleIds }),
  setFilter: (filter) => setFilterOsagoCalculationAction({ filter }),
  setUnselect: (unSelectedVehicleIds) =>
  setUnselectOsagoCalculationAction({ unSelectedVehicleIds }),
  clear: () => clearAction()
};

export const setFilterOsagoCalculation = (filter) => async (
dispatch) =>

dispatch(osagoCalculationActions.setFilter(filter));

export const addFilterOsagoCalculation = (filter) => async (
dispatch) =>

dispatch(osagoCalculationActions.addFilter(filter));

export const setUnselectOsagoCalculation = (
unSelectedVehicleIds) =>
async (dispatch) =>
dispatch(osagoCalculationActions.setUnselect(unSelectedVehicleIds));

export const addUnselectOsagoCalculation = (
unSelectedVehicleIds) =>
async (dispatch) =>
dispatch(osagoCalculationActions.addUnselect(unSelectedVehicleIds));

export const addOsagoCalculation = (
osagoCalculation) =>
async (dispatch) =>
dispatch(osagoCalculationActions.add(osagoCalculation));

export const updateOsagoCalculation = (
osagoCalculation) =>
async (dispatch) =>
dispatch(osagoCalculationActions.update(osagoCalculation));

export const setSelectedVehicles = (selectedVehicleIds) => async (
dispatch) =>

dispatch(osagoCalculationActions.setSelectedVehicles(selectedVehicleIds));

export const deleteOsagoCalculation = (id) => async (
dispatch) =>

dispatch(osagoCalculationActions.delete(id));

export const clearData = () => async (dispatch) =>
dispatch(osagoCalculationActions.clear());

export default osagoCalculationSlice.reducer;
